import { GridTableScroll, Skeleton } from "@/modules/common/components";
import ManagerListHeader, { gridLayout, SKELETON_COLUMNS } from "./ManagerListHeader";
import { cn } from "@/libs/cn";

interface ManagerListSkeletonParams {
  limit?: number;
}

const ManagerListSkeleton = ({ limit = 20 }: ManagerListSkeletonParams) => {
  return (
    <div className="w-full bg-white rounded-lg shadow overflow-hidden relative">
      <GridTableScroll minWidthClassName="md:min-w-[1380px]">
        <ManagerListHeader />

        <div className="divide-y divide-gray-100 md:divide-y-0">
          <div className="flex flex-col gap-3 p-3 md:p-0 md:gap-0">
            {Array.from({ length: limit }).map((_, i) => (
              <div
                key={i}
                className={cn(
                  gridLayout,
                  "bg-white border border-[#D6DEE9] md:rounded-none md:border-0 md:border-t md:bg-transparent rounded-lg",
                )}
              >
                {Array.from({ length: SKELETON_COLUMNS }).map((__, j) => (
                  <Skeleton key={j} className="h-4 w-full" />
                ))}
              </div>
            ))}
          </div>
        </div>
      </GridTableScroll>
    </div>
  );
};

export default ManagerListSkeleton;
